import React, { useState, useEffect, useRef } from 'react';
import { FiStar, FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import HighlightText from './HighlightText';

const GoogleG = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
  </svg>
);

const reviews = [
  { name: 'Lavanya Gupta', time: '9 months ago', text: 'Very nice coaching teachers and experienced. Good institute for students future.', initial: 'L', color: 'bg-blue-700' },
  { name: 'Munesh Sharma', time: 'a year ago', text: 'Best home tutor agency in Lucknow. Highly recommended for all classes.', initial: 'M', color: 'bg-green-700' },
  { name: 'Manoj Tiwari', time: 'a year ago', text: 'Very good site for home tuition. Found an excellent tutor for my daughter.', initial: 'M', color: 'bg-orange-600' },
  { name: 'Arpit', time: '2 years ago', text: 'MyHome Tutors provided me PCM home tutors. I am satisfied with the tutors, thanks!', initial: 'A', color: 'bg-purple-700' },
  { name: 'Priya Sharma', time: '8 months ago', text: 'Excellent service! Got a qualified tutor within 24 hours. Very professional and punctual.', initial: 'P', color: 'bg-pink-700' },
  { name: 'Rahul Singh', time: '6 months ago', text: "My son's grades improved significantly after joining. Highly recommend their tutors.", initial: 'R', color: 'bg-indigo-700' },
  { name: 'Sunita Verma', time: '1 year ago', text: 'Great experience! The tutor was very knowledgeable and patient with my child.', initial: 'S', color: 'bg-teal-700' },
  { name: 'Amit Kumar', time: '5 months ago', text: 'Very professional service. The tutor helped my daughter crack her board exams with flying colors.', initial: 'A', color: 'bg-red-700' },
];

const StarRow = ({ size = 'sm' }) => (
  <div className="flex items-center gap-1">
    {[...Array(5)].map((_, i) => (
      <FiStar key={i} className={`${size === 'sm' ? 'w-4 h-4' : 'w-7 h-7'} fill-current text-yellow-500 stroke-yellow-500`} />
    ))}
  </div>
);

const GoogleReviews = () => {
  const [current, setCurrent] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [direction, setDirection] = useState('right');
  const visibleCount = 3;
  const total = reviews.length;
  const intervalRef = useRef(null);

  const startAuto = () => {
    intervalRef.current = setInterval(() => slide('right'), 4000);
  };

  useEffect(() => {
    startAuto();
    return () => clearInterval(intervalRef.current);
  }, [current]);

  const slide = (dir) => {
    if (isAnimating) return;
    setDirection(dir);
    setIsAnimating(true);
    setTimeout(() => {
      setCurrent(prev => 
        dir === 'right' ? (prev + 1) % total : (prev - 1 + total) % total
      );
      setIsAnimating(false);
    }, 350);
  };

  const handleNav = (dir) => {
    clearInterval(intervalRef.current);
    slide(dir);
  };

  const getVisible = () => {
    const items = [];
    for (let i = 0; i < visibleCount; i++) {
      items.push(reviews[(current + i) % total]);
    }
    return items;
  };

  return (
    <section className="py-24 bg-[#fdf8f4]" id="reviews">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 text-sm font-extrabold tracking-widest uppercase mb-4 text-slate-600">
            <svg className="w-4 h-4 text-primary" fill="currentColor" viewBox="0 0 20 20">
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
            </svg>
            Google Reviews
          </div>
          <h2 className="text-4xl md:text-5xl font-extrabold text-slate-900 tracking-tight">
            <HighlightText>Honest Reviews</HighlightText> from our Customers
          </h2>
        </div>

        <div className="flex flex-col lg:flex-row gap-8 items-stretch">
          
          {/* Left Rating Box - Simplified per Image 1 requirement */}
          <div className="flex flex-col items-center justify-center py-10 px-12 bg-white rounded-3xl shadow-sm border border-gray-100 min-w-[240px] w-full lg:w-auto flex-shrink-0 self-center">
            <GoogleG />
            <div className="mt-3 mb-2">
              <span className="text-[4rem] font-extrabold text-slate-900 leading-none">4.9</span>
            </div>
            <StarRow size="lg" />
          </div>

          {/* Slider */}
          <div className="flex-1 relative overflow-hidden">
            <div 
              className="grid grid-cols-1 md:grid-cols-3 gap-5"
              style={{
                opacity: isAnimating ? 0 : 1,
                transform: isAnimating 
                  ? `translateX(${direction === 'right' ? '-30px' : '30px'})` 
                  : 'translateX(0)',
                transition: 'opacity 0.35s ease, transform 0.35s ease',
              }}
            >
              {getVisible().map((review, idx) => (
                <div key={idx} className="bg-white p-6 rounded-3xl shadow-sm border border-gray-100 flex flex-col">
                  <div className="flex justify-between items-start mb-4">
                    <div className="flex items-center gap-3">
                      <div className={`w-11 h-11 rounded-full flex items-center justify-center font-bold text-base text-white ${review.color}`}>
                        {review.initial}
                      </div>
                      <div>
                        <h4 className="font-extrabold text-slate-900 text-sm leading-tight">{review.name}</h4>
                        <p className="text-xs text-gray-400 font-medium mt-0.5">{review.time}</p>
                      </div>
                    </div>
                    <svg viewBox="0 0 24 24" width="16" height="16" xmlns="http://www.w3.org/2000/svg">
                      <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
                      <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                      <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                      <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
                    </svg>
                  </div>
                  <div className="flex items-center gap-0.5 mb-3">
                    {[...Array(5)].map((_, i) => (
                      <FiStar key={i} className="w-3.5 h-3.5 fill-current text-yellow-400 stroke-yellow-400" />
                    ))}
                  </div>
                  <p className="text-gray-600 text-sm leading-relaxed font-medium flex-1">
                    "{review.text}"
                  </p>
                </div>
              ))}
            </div>

            {/* Nav */}
            <div className="flex items-center justify-between mt-6">
              <div className="flex gap-2">
                {reviews.map((_, i) => (
                  <button 
                    key={i}
                    onClick={() => { clearInterval(intervalRef.current); setCurrent(i); }}
                    className={`h-2 rounded-full transition-all duration-300 ${i === current ? 'bg-primary w-6' : 'bg-gray-300 w-2'}`}
                  />
                ))}
              </div>
              <div className="flex gap-2">
                <button onClick={() => handleNav('left')} className="w-10 h-10 rounded-full bg-white border border-gray-200 flex items-center justify-center hover:bg-primary hover:text-white hover:border-primary transition-all shadow-sm">
                  <FiChevronLeft className="w-5 h-5" />
                </button>
                <button onClick={() => handleNav('right')} className="w-10 h-10 rounded-full bg-white border border-gray-200 flex items-center justify-center hover:bg-primary hover:text-white hover:border-primary transition-all shadow-sm">
                  <FiChevronRight className="w-5 h-5" />
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 text-center">
          <a 
            href="https://www.google.com/maps?cid=6245695101345977885" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-white text-slate-900 border-2 border-slate-200 px-8 py-3.5 rounded-full font-extrabold hover:border-slate-900 transition-all shadow-sm tracking-wide"
          >
            <svg viewBox="0 0 24 24" width="18" height="18" xmlns="http://www.w3.org/2000/svg">
              <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
              <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
              <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
              <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
            </svg>
            Check Google Reviews
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default GoogleReviews;